import React from 'react';
import AritoFormDateRangeDropdown from '@/components/custom/arito/form/form-date-range-dropdown';
import { Label } from '@/components/ui/label';

interface DateRangeFieldProps {
  label?: string;
  fromDateName?: string;
  toDateName?: string;
  labelClassName?: string;
  className?: string;
}

export const DateRangeField: React.FC<DateRangeFieldProps> = ({
  label = 'Ngày c/từ (từ/đến)',
  fromDateName = 'startDate',
  toDateName = 'endDate',
  labelClassName = 'text-sm font-normal text-[13px] pr-2 sm:mb-0 text-left flex items-center min-w-[150px]',
  className = 'flex items-center'
}) => {
  return (
    <div className={className}>
      <Label className={labelClassName}>{label}</Label>
      <AritoFormDateRangeDropdown fromDateName={fromDateName} toDateName={toDateName} />
    </div>
  );
};

export default DateRangeField;
